import { FR, SupportedLanguage } from '../context/LanguageContext';
import GetLangConfig from './LangUtil';

export default function FormatDateLocale(date: Date, userLang?: SupportedLanguage){
    const langConfig = GetLangConfig('DateUtil');
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear();
    let formattedMonth = '';
    switch(month.toString()) {
        case '01': 
            formattedMonth = langConfig.general.january;
            break;
        case '02':
            formattedMonth = langConfig.general.february;
            break;
        case '03':
            formattedMonth = langConfig.general.march;
            break;
        case '04': 
            formattedMonth = langConfig.general.april;
            break;
        case '05':
            formattedMonth = langConfig.general.may;
            break;
        case '06': 
            formattedMonth = langConfig.general.june;
            break;
        case '07': 
            formattedMonth = langConfig.general.july;
            break;
        case '08':
            formattedMonth = langConfig.general.august;
            break;
        case '09': 
            formattedMonth = langConfig.general.september;
            break;
        case '10':
            formattedMonth = langConfig.general.october;
            break;
        case '11': 
            formattedMonth = langConfig.general.november;
            break;
        case '12':
            formattedMonth = langConfig.general.december;
            break;
        default:
            formattedMonth = month;
            break;
    }

    if(date == null){
        return '--';
    } else if (userLang?.startsWith(FR)) {
        return `${day} ${formattedMonth.substring(0,3)} ${year}`;
    } else {
        return `${year} ${formattedMonth.substring(0,3)} ${day}`;


    }

    
    
}